module.exports = __webpack_public_path__ + "static/media/cnpq-logo-01.2aac3a3f.png";